var kind  = require("enyo/kind"),
    utils = require("enyo/utils");

/**
 * [TapCommandSupport]{@link app.ui.TapCommandSupport} allows a button to bubble
 * a named event, in order to provide a command to it's ancestors when it's
 * tapped.
 *
 * @mixin  app.ui.TapCommandSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "app.ui.TapCommandSupport",

    /**
     * The name of the event that'll get bubbled.
     *
     * @name      tapCommand
     * @type      {?string}
     * @default   null
     * @memberof  app.ui.TapCommandSupport
     * @public
     */

    /**
     * Flags whether or not the command should stop propagation of the tap
     * event.
     *
     * @name      propagateTap
     * @type      {boolean}
     * @default   true
     * @memberof  app.ui.TapCommandSupport
     * @public
     */

    /**
     * @memberof  app.ui.TapCommandSupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            if (this.propagateTap === undefined) {
                this.propagateTap = true;
            }
        };
    }),

    /**
     * Bubble up a named command on tap.
     *
     * @param     {enyo.Control}  sender  The sender
     * @param     {Object}        event   The tap event
     * @returns   {boolean}       Whether or not to stop propagation of the tap
     *                            event
     * @memberof  app.ui.TapCommandSupport
     * @method
     * @private
     */
    tap: kind.inherit(function(sup) {
        return function(sender, event) {
            var command = this.get("tapCommand"),
                vent;

            // Modify behavior if we have a tap command
            if (command) {
                sup.apply(this, arguments);
                vent               = utils.clone(event);
                vent.originator    = sender;
                vent.originalEvent = event;
                delete vent.delegate;
                this.bubbleUp(command, vent);

                return this.propagateTap;
            }

            // Default behavior
            return sup.apply(this, arguments);
        };
    })

};
